import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchGatePassDetails = createAsyncThunk(
  "gatePass/fetchGatePassDetails",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${server}/getalldata_gatePass_mongodb`,
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );

      const responseData = response.data?.["body-json"]?.body?.data;

      if (Array.isArray(responseData)) {
        return responseData.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching gate pass details:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const gatePassSlice = createSlice({
  name: "gatePass",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGatePassDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchGatePassDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchGatePassDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default gatePassSlice.reducer;
